import { useTranslation, Trans } from 'next-i18next';

const SleepSection = () => {
  const { t: tSleep } = useTranslation('', { keyPrefix: '$pages.$home.$sleepSection' });
  const { t: tCategory } = useTranslation('', { keyPrefix: '$local.$category' });
  const { t: tProduct } = useTranslation('', { keyPrefix: '$local.$product' });
  const { t: tHomeCommon } = useTranslation('', { keyPrefix: '$pages.$home.$common' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tLinks } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$sleep' });

  return (
    <section className="sleep-section hp-container">
      <div className="tagline">
        <h3 className="font-main-heading-3">{tSleep('taglineTitle')}</h3>
        <p>{tSleep('taglineCopy')}</p>
      </div>
      <div className="wrapper clearfix">
        <div className="images-stack">
          <a href={tLinks('duvet')} className="img-top bed">
            <h3>
              <Trans
                i18nKey="categoryName"
                t={tHomeCommon}
                values={{ categoryName: tProduct('duvet') }}
                components={{ span: <span /> }}
              />
            </h3>
          </a>
          <div className="img-bottom">
            <a href={tLinks('linens')} className="img-bot linen">
              <h3>
                <Trans
                  i18nKey="categoryName"
                  t={tHomeCommon}
                  values={{ categoryName: tCategory('linens') }}
                  components={{ span: <span /> }}
                />
              </h3>
            </a>
            <a href={tLinks('pillows')} className="img-bot pillows">
              <h3>
                <Trans
                  i18nKey="categoryName"
                  t={tHomeCommon}
                  values={{ categoryName: tCategory('pillows') }}
                  components={{ span: <span /> }}
                />
              </h3>
            </a>
          </div>
        </div>
        <div className="text-stack" data-gsap-custom-value="-30" data-gsap="fade-down">
          <p className="font-body-medium intro-text">{tSleep('introText')}</p>
          <h2 className="font-main-heading-3">{tSleep('title')}</h2>
          <p>{tSleep('textBlock')}</p>
          <div className="quote">
            <h3 className="font-main-heading-4">{tSleep('quote')}</h3>
            <span>{tSleep('quoteAuthor')}</span>
          </div>
          <a href={tLinks('main')} className="btn-main">
            {tButton('shopNow')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default SleepSection;
